/**
 * Fixed Loader Component
 *
 * A loader component that is fixed to the viewport, typically used for
 * showing loading states during asynchronous operations without blocking
 * the entire UI.
 *
 * Features:
 * - Fixed positioning that overlays other content
 * - Customizable loading message
 * - Smaller, non-intrusive design
 *
 * @module components/loader/fixed-loader
 */

import { FixedContainer, ValiditySpinner } from "../common-styling";

/**
 * Fixed position loader with message
 *
 * @param {Object} props - Component properties
 * @param {string} props.loaderMessage - Message to display beside the spinner
 * @returns {JSX.Element} Fixed position loader with message
 */
const FixedLoader = ({ loaderMessage }) => {
  return (
    <FixedContainer>
      {/* Small spinner indicator */}
      <ValiditySpinner
        animation="border"
        variant="secondary"
        className="ms-2 rounded-circle"
      />
      {/* Loading message */}
      <small className="ms-2">{loaderMessage}</small>
    </FixedContainer>
  );
};

export default FixedLoader;
